// @mui
import {
  Grid,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import timeArray from '../TimeData';
import EdPaused1Card1 from './EdPaused1Card1';
// components
// ----------------------------------------------------------------------

export default function EdPaused1MainPage() {
  return (
    <>
      <Grid container spacing={1} sx={{ py: 1 }}>
        <EdPaused1Card1 />
      </Grid>
    </>
  );
}
